//项目管理页面接口
import request from '../request.js'


//新增项目  昂少强  
const addData = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'busProContract/busProContractSave',
    })
}

//项目信息回显  昂少强
const getProjectList = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'busProContract/selectProjectsByConditions',
    })
}

//项目删除  昂少强
const deteleProjects = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'busProContract/busProContractDelete',
    })
}

//导出列表  昂少强
const getExportExcel = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'busProContract/getExportExcel',
    })
}




export {
    addData,
    getProjectList,
    deteleProjects,
    getExportExcel
    
}